import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const useGetItemsVersion = (
  sectionThreeListId?: string,
  itemNoVersionId?: string,
  enabled = true,
) =>
  $journalApi.useQuery(
    "get",
    "/api/v1/journals/section-three/{sectionThreeListId}/items/{itemNoVersionId}/versions",
    {
      params: {
        path: {
          sectionThreeListId: sectionThreeListId!,
          itemNoVersionId: itemNoVersionId!,
        },
      },
    },
    {
      enabled: enabled && !!sectionThreeListId && !!itemNoVersionId,
      staleTime: 0,
      refetchOnMount: "always",
    },
  );


